class AxiosIndicator {
    static register = {
        PRODUCT_LISTING_API_CALL: {slug: 'PRODUCT_LISTING_API_CALL'},
        UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL: {slug: 'UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL'},
        PRODUCT_MANUAL_SEARCH_LISTING_API_CALL: {slug: 'PRODUCT_MANUAL_SEARCH_LISTING_API_CALL'},
        SEND_CONTACT_US_EMAIL_API_CALL: {slug: 'SEND_CONTACT_US_EMAIL_API_CALL'},
        SEND_REPORT_ERROR_EMAIL_API_CALL: {slug: 'SEND_REPORT_ERROR_EMAIL_API_CALL'},
        PRODUCT_PRICING_API_CALL: {slug: 'PRODUCT_PRICING_API_CALL'},
        PRODUCT_COMPARE_API_CALL: {slug: 'PRODUCT_COMPARE_API_CALL'},
        PRODUCT_INVENTORY_API_CALL: {slug: 'PRODUCT_INVENTORY_API_CALL'},
        ALERT_API_CALL: {slug: 'ALERT_API_CALL'},
        STOCK_ALERT_API_CALL: {slug: 'STOCK_ALERT_API_CALL'},
        EOL_ALERT_API_CALL: {slug: 'EOL_ALERT_API_CALL'},
        EXPORT_ALERT_API_CALL: {slug: 'EXPORT_ALERT_API_CALL'},
        CART_API_CALL: {slug: 'CART_API_CALL'},
        CART_OPERATION_API_CALL: {slug: 'CART_OPERATION_API_CALL'},
        VIEW_CART_API_CALL: {slug: 'VIEW_CART_API_CALL'},
        SET_DEFAULT_SHIPPING_ADDRESS_API_CALL: {slug: 'SET_DEFAULT_SHIPPING_ADDRESS_API_CALL'},
        SHIPPING_ADDRESS_API_CALL: {slug: 'SHIPPING_ADDRESS_API_CALL'},
        BOM_API_CALL: {slug: 'BOM_API_CALL'},
        BOM_TAB_API_CALL: {slug: 'BOM_TAB_API_CALL'},
        BOM_PROJECT_API_CALL: {slug: 'BOM_PROJECT_API_CALL'},
        BOM_PROJECT_OPERATION_API_CALL: {slug: 'BOM_PROJECT_OPERATION_API_CALL'},
        BOM_PRODUCT_CATEGORY_API_CALL: {slug: 'BOM_PRODUCT_CATEGORY_API_CALL'},
        BOM_OPERATION_API_CALL: {slug: 'BOM_OPERATION_API_CALL'},
        BOM_REMATCH_FLAG_OPERATION_API_CALL: {slug: 'BOM_REMATCH_FLAG_OPERATION_API_CALL'},
        BOM_HEALTH_API_CALL: {slug: 'BOM_HEALTH_API_CALL'},
        BOM_UPLOAD_OPERATION_API_CALL: {slug: 'BOM_UPLOAD_OPERATION_API_CALL'},
        BOM_DOWNLOAD_API_CALL: {slug: 'BOM_DOWNLOAD_API_CALL'},
        BOM_EMAIL_API_CALL: {slug: 'BOM_EMAIL_API_CALL'},
        BOM_SAVE_PREFERENCE_API_CALL: {slug: 'BOM_SAVE_PREFERENCE_API_CALL'},
        BOM_ASSIGN_TO_PROJECT_API_CALL: {slug: 'BOM_ASSIGN_TO_PROJECT_API_CALL'},
        BOM_SWAP_PART_NUMBER_API_CALL: {slug: 'BOM_SWAP_PART_NUMBER_API_CALL'},
        BOM_REMATCH_API_CALL: {SLUG: "BOM_REMATCH_API_CALL"},
        BOM_REMATCH_SAVED_API_CALL: {SLUG: "BOM_REMATCH_SAVED_API_CALL"},
        BOM_REMATCH_SAVED_PREFERENCE_API_CALL: {SLUG: "BOM_REMATCH_SAVED_PREFERENCE_API_CALL"},
        BOM_REMATCH_OPERATION_API_CALL: {SLUG: "BOM_REMATCH_OPERATION_API_CALL"},
        BOM_MULTIPLE_MATCH_PRODUCT_SEARCH: {SLUG: "BOM_MULTIPLE_MATCH_PRODUCT_SEARCH"},
        CART_API_CALL_ON_PAGE_LOADING: {SLUG: "CART_API_CALL_ON_PAGE_LOADING"},
        FORECAST_API_CALL: {slug: 'FORECAST_API_CALL'},
        SHARE_FORECAST_API_CALL: {slug: 'SHARE_FORECAST_API_CALL'},
        PROFILE_API_CALL: {slug: 'PROFILE_API_CALL'},
        ORDER_API_CALL: {slug: 'ORDER_API_CALL'},
        QUOTE_API_CALL: {slug: 'QUOTE_API_CALL'},
        PLACE_ORDER_API_CALL: {slug: 'PLACE_ORDER_API_CALL'},
        ORDER_EMAIL_API_CALL: {slug: 'ORDER_EMAIL_API_CALL'},
        ORDER_HEADER_DETAIL_API_CALL: {slug: 'ORDER_HEADER_DETAIL_API_CALL'},
        QUOTE_DETAIL_API_CALL: {slug: 'QUOTE_DETAIL_API_CALL'},
        LINE_ITEM_API_CALL: {slug: 'LINE_ITEM_API_CALL'},
        ALL_COUNT_API_CALL: {slug: 'ALL_COUNT_API_CALL'},
        COMMON_API_CALL: {slug: 'COMMON_API_CALL'},
        EXPORT_URL: {slug: 'EXPORT_URL'},
        MINI_CART_API_CALL: {slug: 'MINI_CART_API_CALL'},
        ADD_TO_CART_API_CALL:{slug:'ADD_TO_CART_API_CALL'},
        DOCUMENT_API_CALL: { slug: 'DOCUMENT_API_CALL'},
        CONTENT_API_CALL: { slug: 'CONTENT_API_CALL'},
        NEW_PRODUCT_INFORMATION_API_CALL: { slug: 'NEW_PRODUCT_INFORMATION_API_CALL' },
        MANUAL_SEARCH_API_CALL: {slug: 'MANUAL_SEARCH_API_CALL'},
        PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING: {slug: 'PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING'},
        ADD_USER_API_CALL: {slug: 'ADD_USER_API_CALL'},
        USER_API_CALL: {slug: 'USER_API_CALL'},
        USER_LIST_API_CALL: {slug: 'USER_LIST_API_CALL'},
        QUOTE_REASON_API_CALL: {slug: 'QUOTE_REASON_API_CALL'},
        USER_DETAIL_API_CALL: {slug: 'USER_DETAIL_API_CALL'},
        USER_ACCOUNT_API_CALL: {slug: 'USER_ACCOUNT_API_CALL'},
        USER_REPORT_API_CALL: {slug: 'USER_REPORT_API_CALL'},
        REGISTRATION_API_CALL: {slug: 'REGISTRATION_API_CALL'},
        DOWNLOAD_FORECAST_API_CALL: {slug:'DOWNLOAD_FORECAST_API_CALL'},
        CHECK_USER_EMAIL: {slug: 'CHECK_USER_EMAIL'},
        ACCOUNT_DETAIL_API_CALL: {slug: 'ACCOUNT_DETAIL_API_CALL'},
        ACCOUNT_USER_API_CALL: {slug: 'ACCOUNT_USER_API_CALL'},
        ORDER_MANUFACTURE_API_CALL: {slug: 'ORDER_MANUFACTURE_API_CALL'},
        UNSPONSOR_API_CALL: { slug: 'UNSPONSOR_API_CALL' },
        REMOVE_USER_API_CALL: { slug: 'REMOVE_USER_API_CALL' },
        ORDER_LINE_ITEM_EMAIL_API_CALL: {slug: 'ORDER_LINE_ITEM_EMAIL_API_CALL'},
        USER_VERIFICATION_API_CALL: {slug: 'USER_VERIFICATION_API_CALL' },
        ORDER_RETURN_REQUEST_API_CALL: {slug: 'ORDER_RETURN_REQUEST_API_CALL'},
        PRODUCT_INVENTORY_FARNELL_DETAIL: {slug: 'PRODUCT_INVENTORY_FARNELL_DETAIL'},
        CROSS_REFERENCE_SEARCH_PART_API_CALL: {slug: 'CROSS_REFERENCE_SEARCH_PART_API_CALL'},
        BOM_FARNELL_LIST_API_CALL: {slug: 'BOM_FARNELL_LIST_API_CALL'},
        CHECK_CART_ITEM_EXIST: {slug: 'CHECK_CART_ITEM_EXIST'},
    };
}

export default AxiosIndicator;